export enum LoginTypeEnum {
  Unknown = 0,
  UserName = 1,
  Email = 2,
  Sms = 3,
}
